export const EOC_FEEDBACK_ENTRYPOINT_ID = '07551bfc-5486-4265-b9fa-7e540430b3fd';
